import { addShortcodeToEditor, getShortcodeWrapper } from "@/assets/utilities/tinymce/shortodeAddition";
import { parseToHtml } from "@/utility/parseToHtml";

const contactFormConfig = (tinymce, uuid, shortcodeOnClick, templateToAdd) => {
  const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();

  tinymce.activeEditor.windowManager.open({
    title: "Contact Form Options",
    body: {
      type: "panel",
      items: [
        {
          name: "sendEmailsToGroove",
          type: "checkbox",
          checked: false,
          label: "Send email to Groove",
        },
      ],
    },
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "submit",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onSubmit: api => {
      const contactForm = parseToHtml(templateToAdd);

      if (api.getData().sendEmailsToGroove === true) {
        contactForm.getElementById("contact-form").setAttribute("send-email", true);
      }

      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, contactForm.body.innerHTML);
      addShortcodeToEditor(shortcodeWrapper, uuid, parentElement);
      api.close();
    },
  });
};

export { contactFormConfig };
